var n = (t, d, e) => new Promise((a, s) => {
  var c = (r) => {
    try {
      i(e.next(r));
    } catch (o) {
      s(o);
    }
  }, g = (r) => {
    try {
      i(e.throw(r));
    } catch (o) {
      s(o);
    }
  }, i = (r) => r.done ? a(r.value) : Promise.resolve(r.value).then(c, g);
  i((e = e.apply(t, d)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function y(t) {
  return n(this, null, function* () {
    const {
      data: d
    } = yield f.get(
      "/designordercenter/productionOrder/receiver/getAddressCarrierById",
      { params: t }
    );
    return d;
  });
}
export {
  y as getGetAddressCarrierById
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/receiver/getAddressCarrierById/get.js
// module id = 1770
// module chunks = 41